import * as React from "react"
import { cn } from "src/utils/cn"

function Badge({ className, variant = "default", ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2",
        variant === "default" && "border-transparent bg-slate-900 text-white",
        variant === "secondary" && "border-transparent bg-slate-100 text-slate-950",
        variant === "success" && "border-transparent bg-emerald-100 text-emerald-800",
        variant === "info" && "border-transparent bg-blue-100 text-blue-800",
        variant === "destructive" && "border-transparent bg-red-100 text-red-800",
        variant === "outline" && "border-slate-200 text-slate-950",
        className
      )}
      {...props}
    />
  )
}

export { Badge }
